/* Modulo: Hotspots — + dots toggle a single product card docked to the image.
   One card open at a time; outside-click + Escape close. Card is a real link,
   so a click on the open card navigates to the product page.
   Vanilla IIFE. Theme-editor aware. Reduced-motion handled in CSS. No deps. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function initSection(el) {
    if (!el || el.dataset.moduloHspInit === '1') return;
    el.dataset.moduloHspInit = '1';

    var dots = Array.prototype.slice.call(el.querySelectorAll('[data-hsp-dot]'));
    var cards = Array.prototype.slice.call(el.querySelectorAll('[data-hsp-card]'));
    if (!dots.length) return;

    function cardFor(i) {
      for (var c = 0; c < cards.length; c++) {
        if (+cards[c].getAttribute('data-idx') === i) return cards[c];
      }
      return null;
    }

    function closeAll() {
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.remove('is-active');
        dots[d].setAttribute('aria-expanded', 'false');
      }
      for (var c = 0; c < cards.length; c++) {
        cards[c].classList.remove('is-active');
        cards[c].setAttribute('aria-hidden', 'true');
      }
    }

    function open(i) {
      closeAll();
      for (var d = 0; d < dots.length; d++) {
        if (+dots[d].getAttribute('data-idx') === i) {
          dots[d].classList.add('is-active');
          dots[d].setAttribute('aria-expanded', 'true');
        }
      }
      var card = cardFor(i);
      if (card) { card.classList.add('is-active'); card.setAttribute('aria-hidden', 'false'); }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        if (dot.classList.contains('is-active')) closeAll();
        else open(+dot.getAttribute('data-idx'));
      });
    });

    function onDocClick(e) {
      if (e.target.closest && (e.target.closest('[data-hsp-dot]') || e.target.closest('[data-hsp-card]'))) return;
      closeAll();
    }
    function onKey(e) { if (e.key === 'Escape' || e.key === 'Esc') closeAll(); }

    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onKey);

    el.moduloHspTeardown = function () {
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onKey);
      el.dataset.moduloHspInit = '';
    };
  }

  function initAll() {
    var els = document.querySelectorAll('[data-modulo-hsp]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  function sectionTarget(e) {
    var t = e.target;
    if (!t || !t.querySelector) return null;
    if (t.matches && t.matches('[data-modulo-hsp]')) return t;
    return t.querySelector('[data-modulo-hsp]');
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = sectionTarget(e);
    if (el) initSection(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = sectionTarget(e);
    if (el && typeof el.moduloHspTeardown === 'function') el.moduloHspTeardown();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
